import * as React from 'react';
import ModalDefault from "./ModalDefault";
import './index.scss';
import { useContext } from "react";
import Context from "../../../context";


const ModalConfirm = ({ isOpen, header, message, onCancel, onConfirm, loading }) => {
  const { t } = useContext(Context);
  return (
    <ModalDefault
      isOpen={isOpen}
      onBackdropClick={onCancel}
      className="modal-global"
      header={header}
      message={message}
      buttons={[
        <button key={0} onClick={onCancel}>{t('cancel')}</button>,
        <button key={1} onClick={onConfirm}>{t('confirm')}</button>
      ]}
      loading={loading}
    />
  )
}

export default ModalConfirm;
